import { useSyncExternalStore } from 'react';

/**
 * How much of the bottom of the shared map the phone's sheet covers right now (px). The sheet reports it when it
 * settles (not on every drag frame), the map frames its points above it, and `--map-b` lets CSS (the pickup pin)
 * follow it. Wide screens keep it at 0: their panel sits on the left instead.
 */
let bottom = 0;
const listeners = new Set<() => void>();

export function setSheetInset(px: number) {
  const v = Math.max(0, Math.round(px));
  if (v === bottom) return;
  bottom = v;
  if (typeof document !== 'undefined') document.documentElement.style.setProperty('--map-b', `${v}px`);
  listeners.forEach((f) => f());
}

export const sheetInset = () => bottom;

const subscribe = (f: () => void) => {
  listeners.add(f);
  return () => listeners.delete(f);
};

export const useSheetInset = () => useSyncExternalStore(subscribe, sheetInset, sheetInset);
